var assign = require('object-assign');
var moment = require('moment');
var vsprintf = require('sprintf-js').vsprintf;
var cx = require('classnames');
var React = require('react');

var TokenSelector = React.createClass({
    propsTypes: {
        allowNone: React.PropTypes.bool.isRequired,
        createNew: React.PropTypes.bool.isRequired,
        disabled: React.PropTypes.bool.isRequired,
        newCardHelp: React.PropTypes.string.isRequired,
        noneLabel: React.PropTypes.string.isRequired,
        saveBg: React.PropTypes.bool,
        selected: React.PropTypes.function,
        token: React.PropTypes.object,
        tokens: React.PropTypes.arrayOf(React.PropTypes.object).isRequired
    },

    getInitialState: function () {
        return {
            token: this.props.token,
        };
    },

    componentWillReceiveProps(nextProps) {
        if (this.state.token !== null && nextProps.token !== this.state.token) {
          this.setState({
            token: nextProps.token,
          })
        }
    },

    buildChoices: function () {
        var tokens = this.props.tokens.map(function (token, key) {
            var expiry = moment(token.card.expiry);
            var expired = expiry.isBefore();

            var attr = {
                checked: this.state.token && (this.state.token === token.uuid || this.state.token.uuid == token.uuid),
                disabled: this.props.disabled || expired,
                name: "token",
                onChange: this.updateSelectedToken.bind(null, token),
                type: "radio",
                value: token.id
            };

            return <div className={cx('radio', { expired })} key={key}><label>
                <input {...attr} /> <i className="fa fa-credit-card"></i> <span className="card">{token.card.number}</span><br />
                <small className="low">{token.card.name}</small><br />
                <small className="low expires">Expires: {expiry.format('MM/YY')}</small>
            </label></div>;
        }.bind(this));

        var attr;
        if (this.props.createNew) {
            attr = {
                checked: this.state.token === null,
                disabled: this.props.disabled,
                name: "token",
                onChange: this.updateSelectedToken.bind(null, null),
                type: "radio",
                value: 'new'
            };

            tokens.push(<div className="radio" key="new"><label>
                <input {...attr} /> <i className="fa fa-credit-card"></i> Other Card<br />
                <small className="low">{this.props.newCardHelp}</small><br />
            </label></div>);
        }
        if (this.props.allowNone) {
            attr = {
                checked: this.state.token === false,
                disabled: this.props.disabled,
                name: "token",
                onChange: this.updateSelectedToken.bind(null, false),
                type: "radio",
                value: 'none'
            };

            tokens.unshift(<div className="radio" key="none"><label>
                <input {...attr} /> <i className="fa fa-envelope-o"></i> {this.props.noneLabel}<br />
            </label></div>);
        }

        return tokens;
    },

    getDefaultProps: function () {
        return {
            additionalChoices: [],
            allowNone: false,
            disabled: false,
            createNew: true,
            newCardHelp: 'Use a card not listed here.',
            noneLabel: 'No Automatic Payments',
            saveBg: false,
        };
    },

    render: function () {
        return <div>
            {this.buildChoices()}
        </div>;
    },

    updateSelectedToken: function (token, e) {
        this.setState({
          token: token,
        })

        this.props.selected && this.props.selected(token);
    }
})
module.exports = TokenSelector;



// WEBPACK FOOTER //
// ./app/components/Payment/TokenSelector.js